
import { defineComponent, onMounted, computed, reactive } from "vue";
import UserAccountArticlesRepository from "@/repositories/UserAccountArticlesRepository";
import ArticleModel from "@/models/ArticleModel";
import LatestReleaseSendDate from "@/lib/LatestReleaseSendDate";
import SnsShareUrlUtil from "@/lib/SnsShareUrlUtil";
import "@fortawesome/fontawesome-free/js/all";

interface State {
  article: ArticleModel;
  isShowReleaseShareModal: boolean;
}
export default defineComponent({
  setup() {
    const state = reactive<State>({
      article: {} as ArticleModel,
      isShowReleaseShareModal: false
    });
    onMounted(() => {
      showModal();
    });
    const snsShareUrlUtil = new SnsShareUrlUtil();
    const twitterShareUrl = computed(() => {
      return snsShareUrlUtil.twitterUrl(state.article.title, state.article.userAccountName, state.article.articleId);
    });
    const faceBookShareUrl = computed(() => {
      return snsShareUrlUtil.faceBookUrl(state.article.articleId);
    });
    const showModal = async () => {
      try {
        await fetchArticle();
        // 取得してきたリリースの配信時刻がローカルストレージに保存されたリリース配信時刻よりも新しい場合はモーダルを表示する
        const latestReleaseSendDate = new LatestReleaseSendDate();
        if (state.article && new Date(state.article.sendDate) > latestReleaseSendDate.getFromLocalStorage()) {
          state.isShowReleaseShareModal = true;
        }
        // ローカルストレージに取得してきたリリースの配信時刻を保存する
        if (state.article) latestReleaseSendDate.insertToLocalStorage(state.article.sendDate);
      } catch {
        // api通信に失敗しても特に何もしない
      }
    };
    const fetchArticle = async () => {
      const repository = new UserAccountArticlesRepository();
      // 最新1件を取得
      const articles = await repository.index({ limit: 1 });
      state.article = articles[0];
    };
    const closeModal = () => {
      state.isShowReleaseShareModal = false;
    };
    const openSnsShareWindow = (url, windowName, width, height) => {
      let features = "location=no, menubar=no, status=yes, scrollbars=yes, resizable=yes, toolbar=no";
      if (width) {
        if (window.screen.width > width) {
          features += ", left=" + (window.screen.width - width) / 2;
        }
        else {
          width = window.screen.width;
        }
        features += ", width=" + width;
      }
      if (height) {
        if (window.screen.height > height) {
          features += ", top=" + (window.screen.height - height) / 2;
        }
        else {
          height = window.screen.height;
        }
        features += ", height=" + height;
      }
      window.open(url, windowName, features);
    };
    return {
      state,
      fetchArticle,
      showModal,
      closeModal,
      openSnsShareWindow,
      twitterShareUrl,
      faceBookShareUrl,
    };
  }
});
